import { useContext, useLayoutEffect } from "react";
import { ViewerContext } from "dash-ui";

import {
  MULTILINGUAL_ENABLED,
  applyPortalLanguage,
  detectBrowserLanguage,
  resolvePortalLanguage,
  usePortalLanguagePick,
} from "shared/i18n";

/**
 * Applies the portal language: this browser's pick, else the account language,
 * else the browser language. `ignoreAccount` keeps client-facing pages (share
 * links, IDX embeds) in the visitor's language even when a broker opens them.
 * A no-op while the flag is off.
 */
export function usePortalLanguage({
  ignoreAccount,
}: {
  ignoreAccount: boolean;
}) {
  const { account } = useContext(ViewerContext);
  const pick = usePortalLanguagePick();

  const signedIn = !!account?._id && !ignoreAccount;
  const accountLanguage = account?.language ?? null;

  // Layout effect: switch before the first paint of a freshly loaded account.
  useLayoutEffect(() => {
    if (!MULTILINGUAL_ENABLED) return;
    applyPortalLanguage(
      resolvePortalLanguage({
        enabled: MULTILINGUAL_ENABLED,
        pick,
        account: signedIn ? { language: accountLanguage } : null,
        browser: detectBrowserLanguage(),
      })
    );
  }, [pick, signedIn, accountLanguage]);
}
